export const TRIP_STATUS = {
  INITIAL: 'INITIAL',
  PRICEABLE: 'PRICEABLE',
  UNPRICEABLE: 'UNPRICEABLE',
  PRICED: 'PRICED',
  PRICING_ERROR: 'PRICE_ERROR',
  BOOKABLE: 'BOOKABLE'
};